import Regions from '../regions'
import { getTheCheapestPremiumShippingRegion } from '../regions/utils'
import { IShipping, TShippingName } from './types';
import memoizee from 'memoizee';
import {
  SHIPPING_REGULAR_NAME,
  SHIPPING_PREMIUM_NAME,
  SHIPPING_REGULAR_PRICE,
} from './constants';
import { Logger } from 'src/app/services/logger.service';
import { IRegion } from '../regions/types';
import { LIMIT_BOOKS_FOR_DEFAULT_SHIPPING } from '@functions/constants';

export const getShippingRegular = memoizee(
  (): IShipping => ({
    name: SHIPPING_REGULAR_NAME,
    description: 'ポスト投函・追跡あり・日時指定不可・1冊まで<br>全国一律料金',
    price: SHIPPING_REGULAR_PRICE,
    currency: '¥',
  }),
);

export const getShippingPremium = memoizee(
  (region?: IRegion): IShipping => ({
    name: SHIPPING_PREMIUM_NAME,
    description: `対面お渡し・追跡あり・日時指定は現在受付停止中・同時購入5冊まで<br>兵庫県から${(region || getTheCheapestPremiumShippingRegion(Regions)).name}への送料`,
    price: (region || getTheCheapestPremiumShippingRegion(Regions)).fee.premiumShipping,
    currency: '¥',
  }),
);

/** @returns all available shippings */
export const getShippings = (
  region = getTheCheapestPremiumShippingRegion(Regions)
) => [
  getShippingRegular(),
  getShippingPremium(region),
];

const getShippingByNameLog = new Logger('getShippingByName');
export const getShippingByName = (
  name: TShippingName,
  region = getTheCheapestPremiumShippingRegion(Regions),
): IShipping => {
  const log = getShippingByNameLog;

  switch (name) {
    case SHIPPING_PREMIUM_NAME:
      return getShippingPremium(region);
      // break;

    case SHIPPING_REGULAR_NAME:
      return getShippingRegular(/* region */);
      // break;

    default:
      log.error('Can`t recognize', { name }, 'setting regularShipping by default');
      return getShippingRegular(/* region */);
      // break;
  }
}

/** @returns shipping name based on products count */
export const getCurrentShippingName = (
  productsCount: number,
): TShippingName =>
  productsCount <= LIMIT_BOOKS_FOR_DEFAULT_SHIPPING
    ? SHIPPING_REGULAR_NAME
    : SHIPPING_PREMIUM_NAME;

/** @returns shipping based on products count */
export const getCurrentShipping = (
  productsCount: number,
  region = getTheCheapestPremiumShippingRegion(Regions),
): IShipping =>
  getShippingByName(getCurrentShippingName(productsCount), region)

/** comparing chippings by name */
export const compareShippings = (
  shippingA: IShipping, shippingB: IShipping
): boolean =>
  shippingA?.name === shippingB?.name
